(function () {
  'use strict';

  window.CookieUtils = window.CookieUtils || {};

  CookieUtils.getCookie = function (cookieName) {
    var someCookie = document.cookie.split(';').find(function (item) {
      return item.trim().startsWith(cookieName + '=');
    });
    if (someCookie) {
      return someCookie.split('=')[1];
    }
    return null;
  };

  CookieUtils.setCookie = function (name, value, days, options) {
    options = options || {};
    var expires = '';

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    }

    var path = options.path || '/';
    var domain = options.domain || '';
    var secure = options.secure ? '; secure' : '';
    var sameSite = options.sameSite || 'Strict';

    document.cookie =
      name +
      '=' +
      value +
      expires +
      '; path=' +
      path +
      (domain ? '; domain=' + domain : '') +
      secure +
      '; SameSite=' +
      sameSite;
  };

  CookieUtils.deleteCookie = function (name, options) {
    options = options || {};
    CookieUtils.setCookie(name, '', -1, options);
  };

  CookieUtils.areCookiesEnabled = function () {
    var testCookie = 'cookietest';
    CookieUtils.setCookie(testCookie, 'test', 1);
    var enabled = CookieUtils.getCookie(testCookie) === 'test';
    if (enabled) {
      CookieUtils.deleteCookie(testCookie);
    }
    return enabled;
  };

  CookieUtils.getAllCookies = function () {
    var cookies = {};
    if (document.cookie) {
      document.cookie.split(';').forEach(function (cookie) {
        var parts = cookie.trim().split('=');
        if (parts.length === 2) {
          cookies[parts[0]] = parts[1];
        }
      });
    }
    return cookies;
  };
})();
